export default "__VITE_ASSET__CQJ0UxMD__"